import { getWordCase } from 'src/features/common/helpers/string-helpers';
import { CompanyType } from './../../../../common/types/application/business';

export const BUSINESS_TYPE_TO_DIRECTOR_LOOKUP = {
  [CompanyType.PARTNERSHIP]: 'partner',
  [CompanyType.COMPANY]: 'director',
  [CompanyType.CLOSE_CORP]: 'member',
  [CompanyType.NPO]: 'member',
  [CompanyType.TRUST]: 'trustee',
};

export const getBusinessTypeDirectorLookup = (
  isHeading: boolean,
  companyType?: CompanyType,
): string | undefined => {
  if (companyType) {
    const title = BUSINESS_TYPE_TO_DIRECTOR_LOOKUP[companyType];
    return isHeading ? title : `${getWordCase(title)} Id`;
  }
};
